import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import GroupReportsWrapper from "./GroupReportsWrapper.js";
import {
  filterParams,
  generateOriginalValue,
  handleNumDisplay,
} from "../Reports/utils/ReportUtils";
import i18n from "../../modules/Auth/pages/i18n.js";
import { useTranslation } from "react-i18next";

function GroupRoomInventoryReport(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);

  const columns = [
    {
      field: "date",
      headerName: `${t("Date")}`,
      filterParams: filterParams,
      floatingFilterComponentParams: { suppressFilterButton: true },
      dataType: "date",
    },
    {
      field: "hotelId",
      headerName: `${t("Hotel ID")}`,
      hide: false,
      dataType: "varchar",
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      field: "hotelName",
      headerName: `${t("Hotel Name")}`,
      hide: false,
      dataType: "varchar",
    },
    {
      field: "totalOccupancy",
      headerName: `${t("Total Occupancy")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "totalOccupancy"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "availableOccupancy",
      headerName: `${t("Available Occupancy")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) =>
        generateOriginalValue(params, "availableOccupancy"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "availableRooms",
      headerName: `${t("Available Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "availableRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "soldRooms",
      headerName: `${t("Sold Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "soldRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "blockedRooms",
      headerName: `${t("Blocked Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "blockedRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "bookableRooms",
      headerName: `${t("Bookable Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "bookableRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "offlineRooms",
      headerName: `${t("Offline Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "offlineRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "totalRooms",
      headerName: `${t("Total Rooms")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "totalRooms"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
    {
      field: "unassignCount",
      headerName: `${t("Unassign Count")}`,
      filter: "agNumberColumnFilter",
      dataType: "integer",
      aggFunc: "sum",
      valueGetter: (params) => generateOriginalValue(params, "unassignCount"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
    },
  ];

  // Getting the pinned data
  // Setting the pinned row
  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params, rowsData) {
    let result = {};

    for (let i = 0; i < columns.length; i++) {
      if (["integer", "float"].includes(columns[i]["dataType"])) {
        result[columns[i]["field"]] = 0;
      }
    }

    function updateVals(i) {
      Object.keys(result).forEach((fields) => {
        result[fields] += i[`original_${fields}`];
      });
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().map((row) => updateVals(row));

    result["date"] = "Total";

    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <GroupReportsWrapper
      reportName={`${t("Group Room Inventory Report")}`}
      columns={columns}
      reportActualType={"groupRoomInventoryReport"}
      enableDateTypeFilters={false}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      selectedLanguage={props.selectedLanguage}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.hotels[0] };
}
export default connect(mapStateToProps)(GroupRoomInventoryReport);
